'use client';

import React, { useEffect, useState } from 'react';
import "./index.scss";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import DataCompareStrength from "@/components/client/DataCompareStrength";
import NoData from "@/components/client/NoData";
import MatchServices from "@/services/MatchServices";
import LoadingInner from '@/app/loadingInner';

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES.src;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES.src;

const CompareStrength = ({ matchId }) => {
  const [match, setMatch] = useState(null);
  const [comparison, setComparison] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchData = async () => {
      try {
        const matchData = await MatchServices.getMatchAnalysis(matchId);
        setMatch(matchData);
        await fetchComparisonData(matchId);
      } catch (error) {
        console.error("Error fetching match analysis:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchComparisonData = async () => {
      try {
        const comparisonData = await MatchServices.getMatchComparison(matchId);
        setComparison(comparisonData);
      } catch (error) {
        console.error("Error fetching match analysis:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchData();
  }, [matchId]);

  return (
    <CollapsiblePanel
      title="So Sánh Sức Mạnh"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      {loading ? (
        <LoadingInner />
      ) : !match || match.length === 0 ? (
        <NoData />
      ) : (
        <DataCompareStrength match={match} comparison={comparison} />
      )}
    </CollapsiblePanel>
  );
};

export default CompareStrength;
